import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowLeft, Mail, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

const ConfirmationDemande = () => {
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", duration: 0.5 }}
          className="mx-auto mb-6"
        >
          <div className="w-20 h-20 bg-[#FDFBF7] rounded-full flex items-center justify-center mx-auto">
            <CheckCircle2 size={48} className="text-[#C5A028]" />
          </div>
        </motion.div>
        
        <h1 className="text-2xl font-serif text-stone-900 mb-4">
          Demande envoyée avec succès !
        </h1>
        
        <p className="text-stone-600 mb-6">
          Merci pour votre demande de création d'invitation digitale. 
          Notre équipe va étudier votre projet avec attention.
        </p>

        <div className="bg-[#FDFBF7] rounded-xl p-6 mb-6 text-left space-y-4">
          <div className="flex items-start gap-3">
            <Clock className="text-[#C5A028] mt-0.5" size={20} />
            <div>
              <p className="font-medium text-stone-900 text-sm">Délai de réponse</p>
              <p className="text-sm text-stone-600">Nous vous répondrons sous 24 heures</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Mail className="text-[#C5A028] mt-0.5" size={20} />
            <div>
              <p className="font-medium text-stone-900 text-sm">Prochaine étape</p>
              <p className="text-sm text-stone-600">
                Vous recevrez un email avec un devis personnalisé et les prochaines étapes.
              </p>
            </div>
          </div>
        </div>

        <Link to="/">
          <Button className="bg-[#0A0A0A] hover:bg-stone-800 text-white rounded-full px-8">
            <ArrowLeft size={16} className="mr-2" />
            Retour à l'accueil
          </Button>
        </Link>
      </motion.div>
    </div>
  );
};

export default ConfirmationDemande;
